import { render, staticRenderFns } from "./OrganizationTypesField.vue?vue&type=template&id=5f5ed605"
import script from "./OrganizationTypesField.vue?vue&type=script&lang=js"
export * from "./OrganizationTypesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports